import { Dimmer, Loader } from "semantic-ui-react";

import { useApp } from "../hooks";

type Props = {
    page?: boolean;
};

const LazyLoader = ({ page }: Props) => {
    const { theme } = useApp();

    return (
        <Dimmer
            page={page}
            active
            inverted={!theme.inverted}
            className={!theme.inverted ? "dimmer-custom" : ""}
        >
            <Loader inverted={!theme.inverted} size="huge">
                Carregando
            </Loader>
        </Dimmer>
    );
};

export default LazyLoader;
